import { BaseMountingRailArticleProjectProcessor } from './base-mounting-rail-article-project.processor';
import { Connection } from '@3d-scene/model3d/connection';
import { ArticleVO } from '@article/model/vo/article.vo';
import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { ConnectionAreaVO } from '@shared/vo/meta-element.vo';
import { ConnectionInfoUtils } from '@3d-scene/model3d/util/connection-info-utils';

export class MountingRailArticleProjectProcessor extends BaseMountingRailArticleProjectProcessor {
  protected prepareProjectDataByConnectionSelection(selectedConnectionCubes: Connection[], articleToAdd: ArticleVO): any[] {
    const articleConnectableToConnections: boolean = this.isArticleConnectableToAnyConnection(selectedConnectionCubes, articleToAdd);
    if (articleConnectableToConnections) {
      // use common logic to add articles by selected connections
      // in case given article connectable (by requirements/features) to any connection
      return super.prepareProjectDataByConnectionSelection(selectedConnectionCubes, articleToAdd);
    } else {
      // try to add articles as in case when entire articles are selected instead of connections
      // this logic is not needed for mcs projects - adding articles to rail is not allowed there anyway
      const backwardArticleContainers: ArticleContainer[] = ConnectionInfoUtils.getArticleContainersByConnectionCubes(selectedConnectionCubes);
      return this.createRangeOnLineArticleDataByArticles(backwardArticleContainers);
    }
  }

  private isArticleConnectableToAnyConnection(connectionCubes: Connection[], article: ArticleVO): boolean {
    // in case complex article contains base article - this base article needs to be checked instead
    // (since given article doesn't contain giving connections in this case)
    const articleToCheck: ArticleVO = article.baseArticle ? article.baseArticle : article;
    // get free connections - exclude non-accepting connections and determine multipurpose accepting connections by texture area
    const freeAcceptingCubes: Connection[] = ConnectionInfoUtils.filterAcceptingCubes(connectionCubes);
    for (const freeCube of freeAcceptingCubes) {
      const backwardArticle: ArticleVO = freeCube.articleContainer.article;
      const requiredGivingConnection: ConnectionAreaVO = ConnectionInfoUtils.findRequiredConnection(
        articleToCheck,
        backwardArticle,
        freeCube.metaElementVO as ConnectionAreaVO
      );
      if (requiredGivingConnection) {
        return true;
      }
    }
    return false;
  }
}
